export const environment = {
  production: true /* only enabled when packed version of app; disabled during local dev */,
  gmaps_key: "AIzaSyDf1hH0rnxYJop40-KZVgW1x2hP9IIrqyg",
};
